import Script from 'next/script';
import Head from 'next/head';

export function AviouScript() {
    return (
        <>
            <Head>
                {/* Preconnect to https://source.qa.np.dayli.eu */}
                <link rel="preconnect" href="https://source.qa.np.dayli.eu" />
                {/* DNS prefetch as fallback */}
                <link rel="dns-prefetch" href="https://source.qa.np.dayli.eu" />
            </Head>
            <Script
                type="text/javascript"
                src="https://source.dayli.eu/latest-stable/web-component.js"
                strategy="afterInteractive"
            />
        </>
    );
}
